<template>
	<div class="topic_sum">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div class="body-nav" style="justify-content: flex-start;">
											<div class="nav-left">我提交的作品</div>
											<div class="nav-left nav-date">上传截止：{{ endTime }}</div>
										</div>
										<el-table
											id="table"
											:header-cell-style="tableStyle"
											tooltip-effect="dark"
											@selection-change="mulSelectionChange"
											border
											:data="topicSumData2"
											:cell-class-name="cellcb"
											style="width: 100%;margin-bottom: 20px;"
										>
											<el-table-column type="selection" width="55"></el-table-column>
											<el-table-column prop="title" label="作品名称" width="300">
												<template v-slot:default="scope">
													<div style="color: #409EFF;cursor: default;" @click="goRoutes(scope.row)">{{ scope.row.title }}</div>
												</template>
											</el-table-column>
											<el-table-column prop="author" label="作者">
												<template v-slot:default="scope">
													{{ scope.row.author }},{{ scope.row.record }}
												</template>
											</el-table-column>
											<el-table-column prop="projectTypeId" label="作品类型" width="100"></el-table-column>
											<el-table-column prop="learningSectionString" label="学段" width="100"></el-table-column>
											<el-table-column prop="disciplineIdString" label="学科" width="100"></el-table-column>
											<el-table-column prop="createTime" label="上传时间"></el-table-column>
											<el-table-column prop="state" label="审核状态">
												<template slot-scope="scope">
													{{ scope.row.state | rowState }}
												</template>
											</el-table-column>
										</el-table>
										<div>
											<span v-if="isEnd" style="margin-right: 20px;">
												<el-button type="primary" v-if="isEnd" @click="btnClick(0)">上传</el-button>
												<el-button type="info" v-else disabled>上传已截止</el-button>
											</span>
											<el-button type="primary" @click="btnClick(1)">修改</el-button>
											<el-popconfirm title="确定删除吗？" @confirm="delBtn" style="margin: 0 20px;" v-if="isEnd">
												<el-button slot="reference" type="danger">删除</el-button>
											</el-popconfirm>
											<el-button type="info" @click="goBack">返回</el-button>
											<span style="margin-left: 20px;">初审通过、终审通过或超过初审截止时间不允许再修改</span>
										</div>
									</div>
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { getPageListReview, delReview, getReviewInfo, exceedReview } from '@/api/after/newInterface';
export default {
	data() {
		return {
			tableStyle: {
				backgroundColor: '#7e9be2',
				color: '#fff',
				textAlign: 'center'
			},
			isEnd: false,
			endTime: '',
			topicSumData2: [],
			mulSelectVal: [],
			showBtn: false
		};
	},
	filters: {
		rowState(val) {
			if (val == 0) {
				return '待审核';
			}
			if (val == 1) {
				return '初审不通过';
			}
			if (val == 2) {
				return '初审通过';
			}
			if (val == 3) {
				return '终审不通过';
			}
			if (val == 4) {
				return '终审通过';
			}
		}
	},
	created() {
		this.getTime();
		this.getTableInfo();
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		//table复选
		cellcb(row) {
			if ((!this.isEnd && row.columnIndex === 0) || row.row.state == 2 || row.row.state == 4) {
				return 'myCell';
			}
		},
		// 课题表格多选
		mulSelectionChange(val) {
			this.mulSelectVal = val;
		},
		// 删除
		delBtn() {
			if (this.mulSelectVal.length == 0) {
				this.$message.warning('请选择需要删除的数据');
				return;
			}
			let ids = this.mulSelectVal.map(item => item.id).join(',');
			delReview(ids).then(res => {
				if (res.code == 200) {
					this.$message.success('操作成功');
					this.getTableInfo(this.ids);
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		//列表数据
		getTableInfo() {
			getPageListReview({ pageNumber: 1, pageSize: 999, projectId: this.$route.query.rowId, ren: true }).then(res => {
				if (res.code == 200) {
					this.topicSumData2 = res.data.records;
					if (this.topicSumData2.length > 0) {
						this.topicSumData2.forEach(item => {
							if (new Date(this.endTime).getTime() > new Date().getTime()) {
								this.$set(item, 'isEnd', true);
							} else {
								this.$set(item, 'isEnd', false);
							}
						});
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		goRoute(url) {
			this.$router.push(url);
		},
		//截止状态
		getTime() {
			getReviewInfo(this.$route.query.rowId).then(res => {
				if (res.code == 200) {
					this.endTime = res.data.declareEndTime;
					this.isEnd = res.data.isEnd;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		btnClick(type) {
			//0上传 ， 1修改
			if (type == 0) {
				exceedReview({ projectId: this.$route.query.rowId }).then(res => {
					if (res.code == 200) {
						this.$router.push(`/backstage/submitteAppraisalAchievement`);
					} else {
						this.$message.warning(res.data);
					}
				});
			} else {
				if (this.mulSelectVal.length == 0) {
					this.$message.warning('请勾选修改数据');
					return;
				}
				if (this.mulSelectVal.length > 1) {
					this.$message.warning('只能勾选一个数据');
					return;
				}
				let id = this.mulSelectVal[0].id;
				this.$router.push(`/backstage/submitteAppraisalAchievement?id=${id}`);
			}
		},
		goRoutes(row) {
			this.$router.push(`/backstage/submitteInfoAchievement?id=${row.id}`);
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input {
	width: 100%;
}
.btn_wrap {
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	// justify-content: space-between;
}
.pagination {
	display: flex;
	justify-content: center;
}
.body-nav {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
	.nav-left {
		font-size: 20px;
	}
}
.nav-date {
	color: red;
	font-size: 15px !important;
	margin-left: 80px;
}
::v-deep .myCell .el-checkbox__input {
	display: none;
}
</style>
